type Address = {
  address1: string | null | undefined;
  city: string | null | undefined;
  state: string | null | undefined;
  zip: string | null | undefined;
};

export const formatAddressString = <T extends Address>({
  address1,
  city,
  state,
  zip,
}: T) => {
  let address = [address1, city, state].filter(Boolean).join(', ');

  if (zip) {
    address += ` ${zip}`;
  }

  return address;
};
